import React, { useState } from 'react'
import { Modal, Form, Input, Button, message } from 'antd'
import ModalCustom from '../common/Modal/ModalCustom'

const ChangePasswordModal = ({ visible, onCancel, onChangePassword }) => {
  const [form] = Form.useForm()

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      onChangePassword(values)
      // form.resetFields()
    } catch (error) {
      console.log('Validation failed:', error)
    }
  }

  return (
    <ModalCustom
      title="Thay đổi mật khẩu"
      open={visible}
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      footer={[
        <Button key="cancel" onClick={() => {
          form.resetFields()
          onCancel()
        }}>
          Hủy
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Xác nhận
        </Button>
      ]}
    >
      <Form
        form={form}
        layout="horizontal"
        labelAlign="left"
        labelCol={{ span: 8 }}
        style={{
          // maxHeight: '80vh',
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
      >
        <Form.Item
          label="Mật khẩu mới"
          name="password"
          rules={[
            { required: true, message: 'Vui lòng nhập mật khẩu mới!' },
            { min: 6, message: 'Mật khẩu ít nhất 6 ký tự!' }
          ]}
        >
          <Input.Password placeholder="Nhập mật khẩu mới" />
        </Form.Item>

        <Form.Item
          label="Xác nhận mật khẩu mới"
          name="confirmPassword"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Vui lòng xác nhận mật khẩu mới!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve()
                }
                return Promise.reject(new Error('Mật khẩu không khớp!'))
              }
            })
          ]}
        >
          <Input.Password placeholder="Xác nhận mật khẩu mới" />
        </Form.Item>
      </Form>
    </ModalCustom>
  )
}

export default ChangePasswordModal
